import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Helper } from '../../Helper';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../CustomValidators';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmPopupComponent implements OnInit {
  form:any;
  confirm_msg="Are you sure to delete this application?";
  is_confirm=true;
  confirm_popup=false;
  content='';
  constructor(public dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data
      ) { 

      this.form = new FormGroup({
      
        remark:  new FormControl("", []),
        
       
      });
      this.data=data;
        
    }

  ngOnInit() {
       if(this.data.confirm_popup)
          this.confirm_popup=true;
        if(this.data.confirm)
          this.confirm_msg=this.data.confirm
        if(this.data.msg)
          this.confirm_msg=this.data.msg
        if(this.data.content)
          this.content=this.data.content
       
          if(this.data.is_confirm!=null || this.data.is_confirm!=undefined){
          this.is_confirm=this.data.is_confirm
        }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  loading=false;
  submit(){
    console.log(this.form.valid,this.form)
    if(!this.form.valid ){
      return 1;
    }
    this.dialogRef.close( 
       this.form.value.remark==""?"No comments":this.form.value.remark
     );
    // this.loading=true;
    
    
     
    //   this.Helper.makeRequest("admin/setApprovalStatusDecline",this.form.value,"post").subscribe(d=>{
    //     this.dialogRef.close();
    //     this.loading=false;
    //   },(err)=>{
    //     console.log(err.error);
       
    //     this.Helper.showServerErrors(err.error.errors,this.form);
    //     this.Helper.toast(err.error.message,"error")
    //     this.loading=false;
    //     this.Helper.showLoader(false); 
         
    //   })
     
    
    
  }
}
